module.exports = __webpack_public_path__ + "static/img/tb-empty.a858a6e8.png";